/* ==========================================================================
   The Ember Edit — PDP pair module behaviour.

   Three jobs:
   1. Single-select the pair picker and keep every price readout in agreement
      (module total, main add-to-cart button, sticky mobile bar).
   2. Add BOTH items in one request when a pair is ticked, then hand the
      response to Dawn's own cart-notification so the popup behaves normally.
      Every failure path falls back to letting Dawn submit the form untouched.
   3. Resolve the cart-aware state: if the bag already holds an ODD number of
      Ember items, this product IS the half-price one, so swap the module.

   /cart.js exposes product_id but not collections, hence the #mb-ember-ids
   allowlist rendered by snippets/mb-ember-ids.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var box = document.getElementById('mb-pairbox');
  if (!box) return;

  var moneyFormat = box.dataset.moneyFormat || '${{amount}}';
  var basePrice = parseInt(box.dataset.basePrice, 10) || 0;
  var opts = Array.prototype.slice.call(box.querySelectorAll('.mb-pairopt'));

  function money(cents) {
    var n = Number(cents) || 0;
    return String(moneyFormat).replace(
      /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/g,
      function (_, kind) {
        var comma = kind.indexOf('comma_separator') !== -1;
        var noDec = kind.indexOf('no_decimals') !== -1;
        var v = (n / 100).toFixed(noDec ? 0 : 2);
        if (comma) v = v.replace('.', ',');
        var parts = v.split(comma ? ',' : '.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
        return parts.join(comma ? ',' : '.');
      }
    );
  }

  /* ── the product form Dawn already renders ──
     Find the BUTTON first, then walk up to its form. A comma-separated
     querySelector returns the first match in DOCUMENT order, not the first
     selector that matches — and this page carries a second
     form[action*="/cart/add"] (the instalments form) that appears earlier and
     has no add button, so selecting by form silently grabbed the wrong one and
     the button label never updated. */
  var submitBtn = document.querySelector('product-form button[name="add"]')
    || document.querySelector('button[name="add"]');
  var form = (submitBtn && submitBtn.form)
    || document.querySelector('product-form form');
  var submitText = submitBtn ? (submitBtn.querySelector('span') || submitBtn) : null;
  var baseSubmitText = submitText ? submitText.textContent.trim() : 'Add to cart';

  /* ── sticky mobile bar ── */
  var stick = document.createElement('div');
  stick.className = 'mb-mstick';
  stick.innerHTML =
    '<div class="mb-mstick__p" data-stick-price></div>' +
    '<button type="button" class="mb-mstick__btn" data-stick-btn>Add to cart</button>';
  document.body.appendChild(stick);
  document.body.classList.add('mb-has-stick');
  var stickPrice = stick.querySelector('[data-stick-price]');
  var stickBtn = stick.querySelector('[data-stick-btn]');
  stickBtn.addEventListener('click', function () {
    if (submitBtn) submitBtn.click();
  });

  function selected() {
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].classList.contains('is-on')) return opts[i];
    }
    return null;
  }

  function paint() {
    var pick = selected();
    var add = pick ? (parseInt(pick.dataset.add, 10) || 0) : 0;
    var total = basePrice + add;

    var now = box.querySelector('[data-pair-now]');
    var was = box.querySelector('[data-pair-was]');
    if (now) now.textContent = money(total);
    if (was) {
      was.hidden = add === 0;
      was.textContent = money(basePrice + add * 2);
    }
    if (submitText) {
      submitText.textContent = add > 0
        ? 'Add 2 to cart — ' + money(total)
        : baseSubmitText;
    }
    stickPrice.innerHTML = money(total) +
      '<small>' + (add > 0 ? '2 items · 2nd 50% off' : '1 item') + '</small>';
    stickBtn.textContent = add > 0 ? 'Add 2' : 'Add to cart';
  }

  opts.forEach(function (o) {
    o.addEventListener('click', function (e) {
      // The row is a <label>; let the click drive state, not the native toggle,
      // so single-select stays authoritative.
      e.preventDefault();
      var wasOn = o.classList.contains('is-on');
      opts.forEach(function (x) {
        x.classList.remove('is-on');
        var cb = x.querySelector('.mb-pairopt__cb');
        if (cb) cb.checked = false;
      });
      if (!wasOn) {
        o.classList.add('is-on');
        var cb = o.querySelector('.mb-pairopt__cb');
        if (cb) cb.checked = true;
      }
      paint();
    });
  });

  /* ── add both in one request ────────────────────────────────────────────
     Only intercepts when a pair is actually ticked. Anything unexpected and we
     bail out to Dawn's normal submit rather than swallowing the add. */
  if (form) {
    function onPairSubmit(e) {
      var pick = selected();
      if (!pick) return; // nothing ticked — Dawn handles it

      var mainId = form.querySelector('[name="id"]');
      var pairId = pick.dataset.variant;
      if (!mainId || !mainId.value || !pairId) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;

      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(mainId.value), quantity: qty },
            { id: Number(pairId), quantity: 1 }
          ],
          sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble'
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'add failed');
          var notif = document.querySelector('cart-notification');
          if (notif && typeof notif.renderContents === 'function') {
            // Dawn keys the rendered line on the first item's key.
            var first = (data.items && data.items[0]) || {};
            notif.renderContents({ key: first.key, sections: data.sections });
          } else {
            window.location = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          // Never strand the shopper: detach this handler and let the browser
          // submit the form normally. (A named function, because
          // arguments.callee throws under 'use strict' and would have pointed
          // at this catch callback anyway.)
          form.removeEventListener('submit', onPairSubmit, true);
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('aria-busy');
        });
    }
    form.addEventListener('submit', onPairSubmit, true);
  }

  /* ── cart-aware state ──────────────────────────────────────────────────── */
  var emberIds = [];
  try {
    var idsEl = document.getElementById('mb-ember-ids');
    if (idsEl) emberIds = JSON.parse(idsEl.textContent) || [];
  } catch (err) {
    emberIds = []; // malformed -> make no claim rather than a wrong one
  }

  function applyCartState(cart) {
    if (!emberIds.length || !cart || !cart.items) return;
    var qty = 0;
    var firstOther = null;
    cart.items.forEach(function (item) {
      if (emberIds.indexOf(item.product_id) === -1) return;
      qty += item.quantity;
      if (!firstOther) firstOther = item;
    });

    var odd = qty % 2 === 1;
    var oddEl = box.querySelector('[data-pair-state="odd"]');
    var evenEl = box.querySelector('[data-pair-state="even"]');
    if (!oddEl || !evenEl) return;

    oddEl.hidden = !odd;
    evenEl.hidden = odd;

    if (odd && firstOther) {
      var bag = oddEl.querySelector('[data-inbag]');
      if (bag) {
        var img = firstOther.image
          ? '<img src="' + firstOther.image + '" alt="" width="52" height="52">'
          : '<span class="mb-inbag__ph"></span>';
        bag.innerHTML = img +
          '<span><span class="mb-inbag__l">Already in your bag</span>' +
          '<span class="mb-inbag__n">' + (firstOther.product_title || '') + '</span></span>';
      }
      if (submitText) submitText.textContent = 'Add to cart — ' + money(Math.floor(basePrice / 2));
      stickPrice.innerHTML = money(Math.floor(basePrice / 2)) + '<small>50% off — one already in bag</small>';
      stickBtn.textContent = 'Add to cart';
    } else {
      paint();
    }
  }

  var req = 0;
  function refresh() {
    var mine = ++req;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (mine === req) applyCartState(cart); })
      .catch(function () { /* keep the server-rendered state */ });
  }

  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart) { applyCartState(cart); req++; } else { refresh(); }
  });

  paint();
  refresh();
})();
